import React from "react";

export default function ProductBasicInfoSection({
  form,
  categories,
  handleChange,
}) {
  return (
    <>
      <div className="md:col-span-2">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          Basic Information
        </h4>
      </div>

      <div className="grid grid-cols-1 gap-3 md:col-span-2 md:grid-cols-3">
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">
            Item Name
          </label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-slate-900"
            placeholder="Enter item name"
          />
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">
            Category
          </label>
          <select
            name="category_id"
            value={form.category_id}
            onChange={handleChange}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-slate-900"
          >
            <option value="">Select</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">
            Price
          </label>
          <input
            type="number"
            step="0.01"
            min="0"
            name="base_price"
            value={form.base_price}
            onChange={handleChange}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-slate-900"
            placeholder="0.00"
          />
        </div>
      </div>

      <div className="md:col-span-2">
        <label className="mb-1.5 block text-sm font-medium text-slate-700">
          Description
        </label>
        <textarea
          name="details"
          value={form.details}
          onChange={handleChange}
          rows={3}
          className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-slate-900"
          placeholder="Item description"
        />
      </div>
    </>
  );
}